export default __webpack_public_path__ + "./images/lb.2e437b1f.png";